<div class="column-loading" aria-label="Kalenderspalte wird geladen">
  <div class="column-loading-content">
    <div class="loading-card card-one">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="loading-card card-two">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="loading-note">Termine werden geladen</div>
  </div>
</div>

<style lang="less">
  .column-loading {
    --loading-card-offset: 2.4rem;

    position: absolute;
    inset: 0;
    z-index: 6;
    padding: 0.75rem 0.7rem;
    box-sizing: border-box;
    color: var(--cal-text, #2f4858);
    background: color-mix(in srgb, var(--cal-surface, #eceaea) 78%, transparent);

    .column-loading-content {
      position: sticky;
      top: var(--loading-card-offset);
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      align-items: flex-start;
      width: 100%;
    }

    .loading-card {
      min-height: 4.2rem;
      width: min(9.6rem, calc(100% - 0.35rem));
      border-left: 4px solid var(--column-accent, var(--cal-accent, #741e20));
      border-radius: 8px;
      background: var(--cal-bg, #ffffff);
      box-shadow: var(--cal-shadow, 0 18px 36px rgba(47, 72, 88, 0.12));
      padding: 0.55rem 0.65rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 0.38rem;
      opacity: 0.95;
      animation: calendar-loading-pulse 1.25s ease-in-out infinite;

      span {
        display: block;
        height: 0.45rem;
        border-radius: 999px;
        background: color-mix(
          in srgb,
          var(--column-accent, var(--cal-accent, #741e20)) 24%,
          var(--cal-bg, #ffffff)
        );
      }

      span:first-child {
        width: 78%;
      }

      span:nth-child(2) {
        width: 58%;
      }

      span:nth-child(3) {
        width: 42%;
      }
    }

    .card-one {
      margin-top: 0;
    }

    .card-two {
      margin-top: 4.8rem;
      animation-delay: 0.18s;
    }

    .loading-note {
      width: fit-content;
      max-width: 100%;
      padding: 0.3rem 0.45rem;
      background: color-mix(in srgb, var(--cal-bg, #ffffff) 88%, transparent);
      border: 1px solid var(--cal-border-strong, rgba(0, 0, 0, 0.12));
      color: var(--cal-text, #2f4858);
      font-size: 0.72rem;
      font-weight: 800;
      letter-spacing: 0;
    }
  }

  @keyframes calendar-loading-pulse {
    0%,
    100% {
      opacity: 0.56;
      transform: translateY(0);
    }

    50% {
      opacity: 0.96;
      transform: translateY(1px);
    }
  }
</style>
